// extracted by mini-css-extract-plugin
module.exports = {"team":"styles-module--team--D6azo","teamHeader":"styles-module--teamHeader--wOiV_","teamList":"styles-module--teamList--1sysV"};